import { Skeleton as MuiSkeleton, SkeletonProps as MuiSkeletonProps } from '@mui/material';
import { forwardRef } from 'react';

type Props = Pick<
  MuiSkeletonProps,
  'variant' | 'animation' | 'width' | 'height' | 'className' | 'sx' | 'children' | 'aria-hidden'
> & {
  testId?: string;
};

const Skeleton = forwardRef<HTMLSpanElement, Props>(
  (
    {
      variant,
      animation,
      width,
      height,
      className,
      sx,
      children,
      'aria-hidden': ariaHidden,
      testId,
    },
    ref,
  ) => (
    <MuiSkeleton
      variant={variant}
      animation={animation}
      width={width}
      height={height}
      className={className}
      sx={sx}
      aria-hidden={ariaHidden}
      test-id={testId}
      ref={ref}
    >
      {children}
    </MuiSkeleton>
  ),
);

Skeleton.displayName = 'Skeleton';
export type { Props as SkeletonProps };
export default Skeleton;
